// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b2b-lib-radioContainer{padding-bottom:20px}\n", ""]);
// Exports
exports.locals = {
	"radioContainer": "b2b-lib-radioContainer"
};
module.exports = exports;
